import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

function AppShell() {
  return (
    <div className="app-shell">
      <div className="background-orb background-orb-left" />
      <div className="background-orb background-orb-right" />
      <div className="background-grid" />
      <Header />
      <main className="page-shell">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default AppShell;
